module.exports = __webpack_public_path__ + "media/images/icon_list/success-42bbe3cb3f322fe383b009d3f61a22b2.svg";